module.exports = __webpack_public_path__ + "static/img/HOMEPAGE_desktop_background_regular.48a8aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOMEPAGE_desktop_background_regular.png
// module id = W4c8
// module chunks = 0